export {default as currentTabIdMixin} from './current-tab-id';